import { useEffect, useState } from "react";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { GiftAnArticleButonFactory } from "@features/giftAnArticle/utils/helpers";
import { GiftAnArticleVersion } from "@features/giftAnArticle/utils/types";
import { useUserInfo } from "@features/mySph/hooks/useUserInfo";
import { LambdaResponsePayload } from "@routes/Article/types/Alacrity";

type ArticleSubshareProps = {
  isPremium: boolean;
  handleGenerateGiftURLModal: () => void;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  alacrityRes?: LambdaResponsePayload;
  displayNewGiftIcon?: boolean;
  subshareVersion?: GiftAnArticleVersion;
  buttonClassname?: string;
};

const ArticleSubshare = ({
  isPremium = false,
  handleGenerateGiftURLModal,
  setIsModalOpen,
  alacrityRes,
  subshareVersion = GiftAnArticleVersion.default,
  buttonClassname,
}: ArticleSubshareProps): React.ReactElement => {
  const { isSubscriber } = useUserInfo();
  const [isSubshareVisible, setIsSubshareVisible] = useState(false);

  useEffect(() => {
    if (isSubscriber && isPremium) {
      setIsSubshareVisible(true);
    }
  }, [isSubscriber, isPremium]);

  const sendDataToGTM = useGTMDispatch();

  const handleClick = () => {
    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bt subshare",
      eventAction: "click",
      eventLabel: "gift icon clicks for subscribers",
      nonInteraction: false,
    });

    if (alacrityRes) {
      setIsModalOpen(true);
    } else {
      handleGenerateGiftURLModal();
    }
  };

  useEffect(() => {
    if (!isPremium) return;
    if (!isSubscriber) return;

    sendDataToGTM({
      event: "custom_event",
      eventCategory: "bt subshare",
      eventAction: "views",
      eventLabel: "gift icon exposure for subscribers",
      nonInteraction: false,
    });
  }, [isPremium, isSubscriber, sendDataToGTM]);

  const GiftAnArticleButton = GiftAnArticleButonFactory({
    giftAnArticleVersion: subshareVersion,
  });

  return (
    <>
      {isSubshareVisible ? (
        <div data-testid="article-subshare-component" className="h-full">
          <GiftAnArticleButton
            handleClick={handleClick}
            className={buttonClassname}
          />
        </div>
      ) : null}
    </>
  );
};

export default ArticleSubshare;
